// extracted by mini-css-extract-plugin
module.exports = {"preloader":"CardHeaderAvatarPreloader_preloader__30Hk7","skeleton":"CardHeaderAvatarPreloader_skeleton__3wQcX"};